import React, { useState, Suspense, useEffect } from "react";
import "./Agency_Rent.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useRouteMatch,
} from "react-router-dom";
import { FormHelperText } from "@mui/material";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { BsFacebook } from "react-icons/bs";
import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import NavbarSection from "../../DefaultLayout/Navbar";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

import {
  FaUserAlt,
  FaBuilding,
  FaCalendarAlt,
  FaUserTie,
} from "react-icons/fa";
import {
  MdLocalPostOffice,
  MdOutlinePersonAddAlt1,
  MdEmail,
  MdSecurity,
  MdMeetingRoom,
  MdLocationPin,
  MdPriceChange,
} from "react-icons/md";
import { HiOfficeBuilding } from "react-icons/hi";
import { GiRotaryPhone } from "react-icons/gi";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { useFormik, useFormikContext } from "formik";

import { Formik } from "formik";
import * as Yup from "yup";
import { connect, useSelector } from "react-redux";
import { getContentDetails } from "../../actions/cmsAction";
import { postAgencyRent } from "../../actions/agencyRentAction";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  checkEmptyValidation,
  checkEmptyValidationAgree,
  checkEmailValidation,
  checkEmptyDateValidation,
  checkMobileNumberValidation,
} from "../../Helpers/Validation";
import { toast } from "react-toastify";
import ToastifyContainer from "../../components/Toastify/ToastifyContainer";
import $ from "jquery";

const Dealership_lease = (props) => {
  const { frontLabelsName } = props.label;
  // Modal open state
  const [radios, setRadios] = useState(false);
  const [modal, setModal] = React.useState(false);
  const [modal1, setModal1] = React.useState(false);

  const [agency_lease_type, setAgency_lease_type] = useState("");
  const [property, setProperty] = useState("");
  const [address, setAddress] = useState("");
  const [size, setSize] = useState("");
  const [no_of_room, setNo_of_room] = useState("");
  const [rental_price, setRental_price] = useState("");
  const [owner_name, setOwner_name] = useState("");
  const [mobile_number, setMobile_number] = useState("");
  const [home_number, setHome_number] = useState("");
  const [email, setEmail] = useState("");
  const [ss_number, setSs_number] = useState("");
  const [rented_out, setRented_out] = useState(false);
  const [valid_days, setValid_days] = useState("30");
  const [valid_from, setValid_from] = useState(new Date());
  const [agree, setAgree] = useState(false);

  // error state
  const [error_reason, set_Error_reason] = useState("");
  const [error_property, set_Error_Property] = useState("");
  const [error_address, set_Error_Address] = useState("");
  const [error_size, set_Error_Size] = useState("");
  const [error_no_of_room, set_Error_No_of_room] = useState("");
  const [error_rental_price, set_Error_Rental_price] = useState("");
  const [error_owner_name, set_Error_Owner_name] = useState("");
  const [error_mobile_number, set_Error_Mobile_number] = useState("");
  const [error_email, set_Error_Email] = useState("");
  const [error_ss_number, set_Error_Ss_number] = useState("");
  const [error_home_phone, set_Error_Home_phone] = useState("");
  const [error_valid_days, set_Error_Valid_days] = useState("30");
  const [error_valid_from, set_Error_Valid_from] = useState("");
  const [error_agree, set_Error_Agree] = useState("");

  // auth
  const isAuth = useSelector((state) => state.auth.isAuthenticated);
  const getCms = useSelector((state) => state.cmsPages);
  const { cms, loading } = getCms;
  const datass = cms?.data[0];
  const currentLanguageCode = localStorage.getItem("prevLangFront") 
  // localStorage.getItem("i18next")
  // console.log('currentLanguageCode: ', localStorage.getItem("i18next"));


  useEffect(() => {
    window.scrollTo({ top: 0 });
    props.getContentDetails("agency-rent", currentLanguageCode);
  }, [currentLanguageCode]);

  // Toggle for Modal
  
  const toggle = () => {
    let errReason = "";

    // removing data from state
    setProperty("");
    setOwner_name("");
    setMobile_number("");
    setNo_of_room("");
    setRental_price("");
    setSize("");
    setAddress("");
    setEmail("");
    setValid_from(new Date());
    setSs_number("");
    setAgree("");
    setValid_days("30");
    setRented_out(false);
    setHome_number("");

    // removing error noti
    set_Error_reason("");
    set_Error_Address("");
    set_Error_Email("");
    set_Error_Home_phone("");
    set_Error_Mobile_number("");
    set_Error_No_of_room("");
    set_Error_Property("");
    set_Error_Rental_price("");
    set_Error_Size("");
    set_Error_Owner_name("");
    set_Error_Ss_number("");
    set_Error_Agree("");
    set_Error_Valid_from("");

    if (radios == true && agency_lease_type !== "applyForAgencyLease") {
      setModal(!modal);
    } else if (radios == true) {
      setModal1(!modal1);
    } else {
      set_Error_reason(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_select_type").length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_select_type")[0][
                "value"
              ] || "lbl_select_type"
            : "lbl_select_type"
          : "lbl_select_type"
      );
    }
  };
  const toggle1 = () => {
    if (radios == true) {
      setModal1(!modal1);
    }
  };

  const handleSumitOne = (e) => {
    e.preventDefault();
    let validationFlag = true;
    set_Error_Address("");
    set_Error_Email("");
    set_Error_Home_phone("");
    set_Error_Mobile_number("");
    set_Error_No_of_room("");
    set_Error_Property("");
    set_Error_Rental_price("");
    set_Error_Size("");
    let errAddress = "";
    let errSize = "";
    let errOwner = "";
    let errProperty = "";
    let errMobile = "";
    let errRoom = "";
    let errRental = "";

    errAddress = checkEmptyValidation(address, "lbl_address");
    errProperty = checkEmptyValidation(property, "lbl_property");
    errSize = checkEmptyValidation(size, "lbl_size");
    errOwner = checkEmptyValidation(owner_name, "lbl_owner_name");
    errMobile = checkEmptyValidation(mobile_number, "lbl_mobile_number");
    errRoom = checkEmptyValidation(no_of_room, "lbl_rooms_number");
    errRental = checkEmptyValidation(rental_price, "lbl_rental_price");

    if (
      errAddress ||
      errProperty ||
      errSize ||
      errOwner ||
      errMobile ||
      errRoom ||
      errRental
    ) {
      validationFlag = false;
      set_Error_Address(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errAddress).length > 0
            ? frontLabelsName.filter((e) => e.key == errAddress)[0]["value"] ||
              errAddress
            : errAddress
          : errAddress
      );
      set_Error_Property(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errProperty).length > 0
            ? frontLabelsName.filter((e) => e.key == errProperty)[0]["value"] ||
              errProperty
            : errProperty
          : errProperty
      );
      set_Error_Size(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errSize).length > 0
            ? frontLabelsName.filter((e) => e.key == errSize)[0]["value"] || errSize
            : errSize
          : errSize
      );
      set_Error_Owner_name(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errOwner).length > 0
            ? frontLabelsName.filter((e) => e.key == errOwner)[0]["value"] ||
              errOwner
            : errOwner
          : errOwner
      );
      set_Error_Mobile_number(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errMobile).length > 0
            ? frontLabelsName.filter((e) => e.key == errMobile)[0]["value"] ||
              errMobile
            : errMobile
          : errMobile
      );
      set_Error_No_of_room(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errRoom).length > 0
            ? frontLabelsName.filter((e) => e.key == errRoom)[0]["value"] || errRoom
            : errRoom
          : errRoom
      );
      set_Error_Rental_price(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errRental).length > 0
            ? frontLabelsName.filter((e) => e.key == errRental)[0]["value"] ||
              errRental
            : errRental
          : errRental
      );
    } else {
      validationFlag = true;
      set_Error_Address("");
      set_Error_Property("");
      set_Error_Size("");
      set_Error_Owner_name("");
      set_Error_Mobile_number("");
      set_Error_No_of_room("");
      set_Error_Rental_price("");
    }
    if (validationFlag) {
      const data = {
        agency_lease_type: agency_lease_type,
        property: property,
        address: address,
        size: size,
        no_of_rooms: no_of_room,
        rental_price: priceFormat(rental_price),
        owner_name: owner_name,
        mobile_number: mobile_number,
      };
      props.postAgencyRent(data).then((res) => {
        toast.success(    frontLabelsName
          ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
            ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
            "value"
            ] || res.data.message
            : res.data.message
          : res.data.message);
        setModal(false);
        setAgency_lease_type("");
        setRadios(false);
        const radioss = document.querySelectorAll("input[type='radio']");
        radioss.forEach((radios) => {
          if (radios.checked === true) {
            radios.checked = false;
          }
        });
      });
    }
  };

  // modal 2

  const handleSubmitTwo = (e) => {
    e.preventDefault();
    let validationFlag = true;
    set_Error_Email("");
    set_Error_Home_phone("");
    set_Error_Mobile_number("");
    set_Error_No_of_room("");
    set_Error_Property("");
    set_Error_Ss_number("");
    set_Error_Valid_from("");
    let errEmail = "";
    let errOwner = "";
    let errSS_number = "";
    let errProperty = "";
    let errMobile = "";
    // let errRoom = "";
    let errAgree = "";
    let errValidfrom = "";
    let errHome = "";

    errSS_number = checkEmptyValidation(ss_number, "lbl_social_security_no");
    errProperty = checkEmptyValidation(property, "lbl_property");
    errEmail = checkEmailValidation(email, "lbl_email");
    errOwner = checkEmptyValidation(owner_name, "lbl_owner_name");
    errMobile = checkEmptyValidation(mobile_number, "lbl_mobile_number");
    errHome = checkEmptyValidation(home_number, "lbl_home_number_no");
    // errRoom = checkEmptyValidation(no_of_room, "Room's number");
    errValidfrom = checkEmptyDateValidation(valid_from, "lbl_valid_from");
    errAgree = checkEmptyValidationAgree(agree, "lbl_aggrement_no");

    if (
      errSS_number ||
      errProperty ||
      errEmail ||
      errOwner ||
      errMobile ||
      // errRoom ||
      errAgree ||
      errValidfrom ||
      errHome
    ) {
      validationFlag = false;
      set_Error_Email(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errEmail).length > 0
            ? frontLabelsName.filter((e) => e.key == errEmail)[0]["value"] ||
              errEmail
            : errEmail
          : errEmail
      );
      set_Error_Property(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errProperty).length > 0
            ? frontLabelsName.filter((e) => e.key == errProperty)[0]["value"] ||
              errProperty
            : errProperty
          : errProperty
      );
      set_Error_Ss_number(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errSS_number).length > 0
            ? frontLabelsName.filter((e) => e.key == errSS_number)[0]["value"] ||
              errSS_number
            : errSS_number
          : errSS_number
      );
      set_Error_Owner_name(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errOwner).length > 0
            ? frontLabelsName.filter((e) => e.key == errOwner)[0]["value"] ||
              errOwner
            : errOwner
          : errOwner
      );
      set_Error_Home_phone(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errHome).length > 0
            ? frontLabelsName.filter((e) => e.key == errHome)[0]["value"] || errHome
            : errHome
          : errHome
      );
      set_Error_Mobile_number(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errMobile).length > 0
            ? frontLabelsName.filter((e) => e.key == errMobile)[0]["value"] ||
              errMobile
            : errMobile
          : errMobile
      );
      // set_Error_No_of_room(errRoom);
      set_Error_Valid_from(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errValidfrom).length > 0
            ? frontLabelsName.filter((e) => e.key == errValidfrom)[0]["value"] ||
              errValidfrom
            : errValidfrom
          : errValidfrom
      );
      set_Error_Agree(
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == errAgree).length > 0
            ? frontLabelsName.filter((e) => e.key == errAgree)[0]["value"] ||
              errAgree
            : errAgree
          : errAgree
      );
    } else {
      validationFlag = true;
      set_Error_Email("");
      set_Error_Property("");
      set_Error_Ss_number("");
      set_Error_Owner_name("");
      set_Error_Home_phone("");
      set_Error_Mobile_number("");
      // set_Error_No_of_room("");
      set_Error_Agree("");
      set_Error_Valid_from("");
    }
    if (validationFlag) {
      const data = {
        agency_lease_type: agency_lease_type,
        property: property,
        owner_name: owner_name,
        ss_number: ss_number,
        home_phone: home_number,
        // no_of_rooms: no_of_room,
        email: email,
        valid_from: moment(valid_from).format("YYYY-MM-DD"),
        valid_days: rented_out !== true ? valid_days : 0,
        mobile_number: mobile_number,
      };
      props.postAgencyRent(data).then((res) => {
        setModal1(false);
        setAgency_lease_type("");
        setRadios(false);
        const radioss = document.querySelectorAll("input[type='radio']");
        radioss.forEach((radios) => {
          if (radios.checked === true) {
            radios.checked = false;
          }
        });
      });
    }
  };

  function priceFormat(x) {
    const data = x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }

  const handleRentalPrice = (e) => {
    let parts = e.target.value.split(",");
    let v = parts[0].replace(/\D/g, ""),
      dec = parts[1];
    let calc_num = Number(dec !== undefined ? v + "," + dec : v);
    // use this for numeric calculations
    // console.log('number for calculations: ', calc_num);
    let n = new Intl.NumberFormat("en-DE").format(v);
    n = dec !== undefined ? n + "," + dec : n;

    setRental_price(n);

    set_Error_Rental_price("");
  };

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        {isAuth ? <LoggedHeader /> : <Header />}
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      {!loading && datass && (
        <div className="container-fluid">
          <div className="main-login-new-prww">
            <div className="box-new-rg">
              <div className={`main-delarship p-3 `}>
                <div className="row">
                  <h2>{datass?.title}</h2>
                  <div>
                    <div
                      dangerouslySetInnerHTML={{ __html: datass?.content }}
                    />
                  </div>
                  <div className="bottom-checkbox new">
                    <div class="form-check" onClick={() => setRadios(true)}>
                      {/* <input
                        class="form-check-input"
                        type="radio"
                        id="flexRadioDefault1"
                        name="apply_for_agency_lease"
                        value="sendQueryRegardingAgencyLease"
                        onChange={(e) => setAgency_lease_type(e.target.value)}
                      /> */}
                      {/* <label class="form-check-label" for="flexRadioDefault1">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_send_query")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_send_query"
                              )[0]["value"] || "lbl_send_query"
                            : "lbl_send_query"
                          : "lbl_send_query"}
                      </label> */}
                             <label class="form-check-label" for="flexRadioDefault1">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_intersted_in_listing_property")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_intersted_in_listing_property"
                              )[0]["value"] || "lbl_intersted_in_listing_property"
                            : "lbl_intersted_in_listing_property"
                          : "lbl_intersted_in_listing_property"}
                      </label>
                    </div>
                    <div class="form-check" onClick={() => setRadios(true)}>
                      <input
                        class="form-check-input"
                        type="radio"
                        id="flexRadioDefault2"
                        name="apply_for_agency_lease"
                        value="applyForAgencyLease"
                        onChange={(e) => setAgency_lease_type(e.target.value)}
                      />
                      {/* <label class="form-check-label" for="flexRadioDefault2">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_apply_agency_lease"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_apply_agency_lease"
                              )[0]["value"] || "lbl_apply_agency_lease"
                            : "lbl_apply_agency_lease"
                          : "lbl_apply_agency_lease"}
                      </label> */}
                       <label class="form-check-label" for="flexRadioDefault2">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_traditional_brokerage"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_traditional_brokerage"
                              )[0]["value"] || "lbl_traditional_brokerage"
                            : "lbl_traditional_brokerage"
                          : "lbl_traditional_brokerage"}
                      </label>
                    </div>
                    <div class="form-check" onClick={() => setRadios(true)}>
                      <input
                        class="form-check-input"
                        type="radio"
                        id="flexRadioDefault3"
                        name="apply_for_agency_lease"
                        onChange={(e) => setAgency_lease_type(e.target.value)}
                        value="continuousRental"
                      />
                      {/* <label class="form-check-label" for="flexRadioDefault3">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_continuous_rental"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_continuous_rental"
                              )[0]["value"] || "lbl_continuous_rental"
                            : "lbl_continuous_rental"
                          : "lbl_continuous_rental"}
                      </label> */}
                      <label>
                         {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_continuous_brokerage"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_continuous_brokerage"
                              )[0]["value"] || "lbl_continuous_brokerage"
                            : "lbl_continuous_brokerage"
                          : "lbl_continuous_brokerage"}
                      </label>
                    </div>
                    <div class="form-check" onClick={() => setRadios(true)}>
                      <input
                        class="form-check-input"
                        type="radio"
                        id="flexRadioDefault4"
                        name="apply_for_agency_lease"
                        value="transferOfLease"
                        onChange={(e) => setAgency_lease_type(e.target.value)}
                      />
                      {/* <label class="form-check-label" for="flexRadioDefault4">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_transfer_lease"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_transfer_lease"
                              )[0]["value"] || "lbl_transfer_lease"
                            : "lbl_transfer_lease"
                          : "lbl_transfer_lease"}
                      </label> */}
                        <label class="form-check-label" for="flexRadioDefault4">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_lease_transfer"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_lease_transfer"
                              )[0]["value"] || "lbl_lease_transfer"
                            : "lbl_lease_transfer"
                          : "lbl_lease_transfer"}
                      </label>
                    </div>
                  </div>
                  {error_reason && (
                    <span className="invalid_span">{error_reason}</span>
                  )}
                  <div className="bottom-delar-ship-btn pt-3">
                    <button onClick={toggle} type="submit">
                      {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_confirm")
                            .length > 0
                          ? frontLabelsName.filter((e) => e.key == "lbl_confirm")[0][
                              "value"
                            ] || "lbl_confirm"
                          : "lbl_confirm"
                        : "lbl_confirm"}
                    </button>
                  </div>
                            
                  <Modal
                    isOpen={modal}
                    toggle={toggle}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className={`${
                      agency_lease_type !== "applyForAgencyLease" &&
                      "modal-style1"
                    }`}
                  >
                    <ModalBody>
                      <form className="p-3">
                        <div className="mb-4 pt-2">
                          <div className="serach-space-set  cum-space">
                            <input
                              type="text"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_property"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_property"
                                      )[0]["value"] || "lbl_property"
                                    : "lbl_property"
                                  : "lbl_property"
                              }
                              className="border-input"
                              name="property"
                              onChange={(e) => {
                                set_Error_Property("");
                                setProperty(e.target.value);
                              }}
                              value={property}
                            />
                            <span>
                              <FaBuilding className="set-top" />
                            </span>
                          </div>
                          {error_property && (
                            <span className="invalid_span">
                              {error_property}
                            </span>
                          )}
                        </div>

                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="text"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_address"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_address"
                                      )[0]["value"] || "lbl_address"
                                    : "lbl_address"
                                  : "lbl_address"
                              }
                              name="address"
                              onChange={(e) => {
                                set_Error_Address("");
                                setAddress(e.target.value);
                              }}
                              value={address}
                            />
                            <span>
                              <MdLocationPin className="set-top" />
                            </span>
                          </div>
                          {error_address && (
                            <span className="invalid_span">
                              {error_address}
                            </span>
                          )}
                        </div>
                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="number"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_size"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_size"
                                      )[0]["value"] || "lbl_size"
                                    : "lbl_size"
                                  : "lbl_size"
                              }
                              name="size"
                              onChange={(e) => {
                                set_Error_Size("");
                                setSize(e.target.value);
                              }}
                              value={size}
                            />
                            <span>
                              <HiOfficeBuilding className="set-top" />
                            </span>
                          </div>
                          {error_size && (
                            <span className="invalid_span">{error_size}</span>
                          )}
                        </div>
                        <div className="mb-4">
                          {/* <div className="serach-space-set  cum-space">
                            <select
                              class="form-select custom-select"
                              aria-label="Default select example"
                              placeholder="No of Room"
                              onChange={(e) => {
                                set_Error_No_of_room("");
                                setNo_of_room(e.target.value);
                              }}
                              required
                            >
                              <option value="">No of Room</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6+</option>
                            </select>
                            <span>
                              <MdMeetingRoom className="set-top" />
                            </span>
                          </div> */}
                          <div className="serach-space-set  cum-space form-group1 set-bg-feild11">
                            <label
                              for="exampleFormControlSelect1"
                              className={`position-absolute ${
                                no_of_room.length > 0
                                  ? "placeholder1"
                                  : "placeholder2"
                              }`}
                            >
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_room")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_room"
                                    )[0]["value"] || "lbl_room"
                                  : "lbl_room"
                                : "lbl_room"}
                            </label>
                            <select
                              className="form-select111 custom-select11 set-bg-input placeholder1"
                              id="exampleFormControlSelect1"
                              // className="form-control"
                              aria-label="Default select example"
                              label="Number of room"
                              onChange={(e) => {
                                set_Error_No_of_room("");
                                setNo_of_room(e.target.value);
                              }}
                              required
                              placeholder="Number of room"
                            >
                              <option
                                value=""
                                disabled
                                selected
                                style={{ display: "none" }}
                              ></option>
                                     <option value="Storage">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_storage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_storage")[0]["value"] ||
            "lbl_storage"
          : "lbl_storage"
        : "lbl_storage"}</option>
                              <option value="1">{frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_single_room").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_single_room")[0]["value"] ||
            "lbl_single_room"
          : "lbl_single_room"
        : "lbl_single_room"}</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="5">8</option>
                              <option value="9">9+</option>
                            </select>
                            <span>
                              <MdMeetingRoom className="set-top" />
                            </span>
                          </div>
                          {error_no_of_room && (
                            <span className="invalid_span">
                              {error_no_of_room}
                            </span>
                          )}
                        </div>
                        <div className="mb-4">
                          <div className="serach-space-set  cum-space">
                            <input
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_rental_price"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_rental_price"
                                      )[0]["value"] || "lbl_rental_price"
                                    : "lbl_rental_price"
                                  : "lbl_rental_price"
                              }
                              name="rental_price"
                              onChange={(e) => handleRentalPrice(e)}
                              value={rental_price}
                              type="text"
                              pattern="[0-9.,]+"
                              id="price"
                              required
                              data-type="number"
                            />
                            <span>
                              <MdPriceChange className="set-top" />
                            </span>
                          </div>
                          {error_rental_price && (
                            <span className="invalid_span">
                              {error_rental_price}
                            </span>
                          )}
                        </div>
                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="text"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_owner_name"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_owner_name"
                                      )[0]["value"] || "lbl_owner_name"
                                    : "lbl_owner_name"
                                  : "lbl_owner_name"
                              }
                              name="owner_name"
                              onChange={(e) => {
                                set_Error_Owner_name("");
                                setOwner_name(e.target.value);
                              }}
                              value={owner_name}
                            />
                            <span>
                              <FaUserTie className="set-top" />
                            </span>
                          </div>
                          {error_owner_name && (
                            <span className="invalid_span">
                              {error_owner_name}
                            </span>
                          )}
                        </div>
                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="number"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_mobile_no"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_mobile_no"
                                      )[0]["value"] || "lbl_mobile_no"
                                    : "lbl_mobile_no"
                                  : "lbl_mobile_no"
                              }
                              name="mobile_number"
                              onChange={(e) => {
                                set_Error_Mobile_number("");
                                setMobile_number(e.target.value);
                              }}
                              value={mobile_number}
                            />
                            <span>
                              <GiRotaryPhone className="set-top" />
                            </span>
                          </div>
                          {error_mobile_number && (
                            <span className="invalid_span">
                              {error_mobile_number}
                            </span>
                          )}
                        </div>

                        <div className="button-center text-center pt-3">
                          <button type="submit" onClick={handleSumitOne}>
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_send")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_send"
                                  )[0]["value"] || "lbl_send"
                                : "lbl_send"
                              : "lbl_send"}
                          </button>
                        </div>
                      </form>
                    </ModalBody>
                  </Modal>

                  <Modal
                    isOpen={modal1}
                    toggle={toggle1}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    className={`${
                      agency_lease_type === "applyForAgencyLease" &&
                      "modal-style2"
                    } `}
                  >
                    <ModalBody>
                      <form className="p-4">
                        <div className="mb-4 ">
                          <div className="serach-space-set  cum-space">
                            <input
                              type="text"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_property"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_property"
                                      )[0]["value"] || "lbl_property"
                                    : "lbl_property"
                                  : "lbl_property"
                              }
                              className="border-input"
                              name="property"
                              onChange={(e) => {
                                set_Error_Property("");
                                setProperty(e.target.value);
                              }}
                              value={property}
                            />
                            <span>
                              <FaBuilding className="set-top" />
                            </span>
                          </div>
                          {error_property && (
                            <span className="invalid_span">
                              {error_property}
                            </span>
                          )}
                        </div>
                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="text"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_owner_name"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_owner_name"
                                      )[0]["value"] || "lbl_owner_name"
                                    : "lbl_owner_name"
                                  : "lbl_owner_name"
                              }
                              name="owner_name"
                              onChange={(e) => {
                                set_Error_Owner_name("");
                                setOwner_name(e.target.value);
                              }}
                              value={owner_name}
                            />
                            <span>
                              <FaUserTie className="set-top" />
                            </span>
                          </div>
                          {error_owner_name && (
                            <span className="invalid_span">
                              {error_owner_name}
                            </span>
                          )}
                        </div>
                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="text"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_social_security_no"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_social_security_no"
                                      )[0]["value"] || "lbl_social_security_no"
                                    : "lbl_social_security_no"
                                  : "lbl_social_security_no"
                              }
                              name="ss_number"
                              onChange={(e) => {
                                set_Error_Ss_number("");
                                setSs_number(e.target.value);
                              }}
                              value={ss_number}
                            />
                            <span>
                              <MdSecurity className="set-top" />
                            </span>
                          </div>
                          {error_ss_number && (
                            <span className="invalid_span">
                              {error_ss_number}
                            </span>
                          )}
                        </div>
                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="number"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_home_phone"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_home_phone"
                                      )[0]["value"] || "lbl_home_phone"
                                    : "lbl_home_phone"
                                  : "lbl_home_phone"
                              }
                              name="Home phone"
                              onChange={(e) => {
                                set_Error_Home_phone("");
                                setHome_number(e.target.value);
                              }}
                              value={home_number}
                            />
                            <span>
                              <GiRotaryPhone className="set-top" />
                            </span>
                          </div>
                          {error_home_phone && (
                            <span className="invalid_span">
                              {error_home_phone}
                            </span>
                          )}
                        </div>

                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="number"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_mobile_no"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_mobile_no"
                                      )[0]["value"] || "lbl_mobile_no"
                                    : "lbl_mobile_no"
                                  : "lbl_mobile_no"
                              }
                              name="Mobile Number"
                              onChange={(e) => {
                                set_Error_Mobile_number("");
                                setMobile_number(e.target.value);
                              }}
                              value={mobile_number}
                            />
                            <span>
                              <GiRotaryPhone className="set-top" />
                            </span>
                          </div>
                          {error_mobile_number && (
                            <span className="invalid_span">
                              {error_mobile_number}
                            </span>
                          )}
                        </div>

                        {/* <div className="mb-4">
                          <div className="serach-space-set  cum-space form-group1 set-bg-feild11">
                            <label for="exampleFormControlSelect1" className={`position-absolute ${no_of_room.length > 0 ? "placeholder1" : "placeholder2"}`} >Room</label>
                            <select
                              className="form-select111 custom-select11 set-bg-input1 placeholder1"
                              id="exampleFormControlSelect1"
                              aria-label="Default select example"
                              label="Number of room"
                              onChange={(e) => {
                                set_Error_No_of_room("");
                                setNo_of_room(e.target.value);
                              }}
                              required
                              placeholder="Number of room"
                            >
                              <option value="" disabled selected style={{display:'none'}}></option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                            </select>
                            <span>
                              <MdMeetingRoom className="set-top" />
                            </span>
                          </div>
                          {error_no_of_room && (
                            <span className="invalid_span">
                              {error_no_of_room}
                            </span>
                          )}
                        </div> */}

                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <input
                              type="email"
                              placeholder={
                                frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_email"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_email"
                                      )[0]["value"] || "lbl_email"
                                    : "lbl_email"
                                  : "lbl_email"
                              }
                              name="email"
                              onChange={(e) => {
                                set_Error_Email("");
                                setEmail(e.target.value);
                              }}
                              value={email}
                            />
                            <span>
                              <MdEmail className="set-top" />
                            </span>
                          </div>
                          {error_email && (
                            <span className="invalid_span">{error_email}</span>
                          )}
                        </div>

                        <div className="mb-4">
                          <div className="serach-space-set cum-space">
                            <DatePicker
                              placeholderText="Valid From"
                              dateFormat="dd/MM/yyyy "
                              name="valid_from"
                              selected={valid_from}
                              onChange={(e) => setValid_from(e)}
                              className="zip-code"
                              isClearable={valid_from ? true : false}
                              minDate={new Date()}
                            />
                            <span>
                              <FaCalendarAlt className="set-top" />
                            </span>
                          </div>
                          {error_valid_from && (
                            <span className="invalid_span">
                              {error_valid_from}
                            </span>
                          )}
                        </div>

                        <div className="mb-4 d-flex">
                          <div className="col-5">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                value=""
                                id="flexCheckChecked"
                                onChange={(e) => {
                                  setRented_out(!rented_out);
                                }}
                              />
                              <label
                                for="flexCheckChecked"
                                className="check-input-style"
                              >
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) =>
                                        e.key == "lbl_until_property_rented"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) =>
                                          e.key == "lbl_until_property_rented"
                                      )[0]["value"] ||
                                      "lbl_until_property_rented"
                                    : "lbl_until_property_rented"
                                  : "lbl_until_property_rented"}
                              </label>
                            </div>
                          </div>
                          <div className="col-2">
                            <p className="text-center check-input-style">
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == "lbl_or")
                                    .length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_or"
                                    )[0]["value"] || "lbl_or"
                                  : "lbl_or"
                                : "lbl_or"}
                            </p>
                          </div>
                          <div className="col-5 set-bg-feild112 serach-space-set">
                            <select
                              // class="form-select"
                              aria-label="Default select example"
                              disabled={rented_out ? true : false}
                              onChange={(e) => {
                                setValid_days(e.target.value);
                              }}
                            >
                              <option value="1">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_today"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_today"
                                      )[0]["value"] || "lbl_today"
                                    : "lbl_today"
                                  : "lbl_today"}
                              </option>
                              <option value="30" selected>
                                30
                              </option>
                              <option value="60">60</option>
                              <option value="90">90</option>
                              <option value="120">120</option>
                              <option value="150">150</option>
                              <option value="180">180</option>
                              <option value="210">210</option>
                              <option value="240">240</option>
                              <option value="270">270</option>
                              <option value="300">300</option>
                              <option value="330">330</option>
                              <option value="360">360</option>
                            </select>
                          </div>
                          {/* {error_valid_days && (
                            <span className="invalid_span">
                              {error_valid_days}
                            </span>
                          )} */}
                        </div>

                        <div className="mb-4">
                          <div className="d-flex flex-column">
                            <div className="d-flex align-items-center">
                              <span className="check-input-style">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_agree"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_agree"
                                      )[0]["value"] || "lbl_agree"
                                    : "lbl_agree"
                                  : "lbl_agree"}
                              </span>
                              <div className="form-check d-flex align-items-center">
                                <input
                                  className="form-check-input mx-2"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  id="inlineRadio1"
                                  value="true"
                                  onChange={(e) => {
                                    set_Error_Agree("");
                                    setAgree(e.target.value);
                                  }}
                                />
                                <label
                                  className="form-check-label check-input-style"
                                  for="inlineRadio1"
                                >
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_yes"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_yes"
                                        )[0]["value"] || "lbl_yes"
                                      : "lbl_yes"
                                    : "lbl_yes"}
                                </label>
                              </div>
                              <div className="form-check form-check-inline mx-3 d-flex align-items-center bottom-checkbox new">
                                <input
                                  className="form-check-input "
                                  type="radio"
                                  name="inlineRadioOptions"
                                  id="inlineRadio2"
                                  value="false"
                                  onChange={(e) => {
                                    set_Error_Agree("");
                                    setAgree(e.target.value);
                                  }}
                                />
                                <label
                                  className="form-check-label mx-2 check-input-style"
                                  for="inlineRadio2"
                                >
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_no"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_no"
                                        )[0]["value"] || "lbl_no"
                                      : "lbl_no"
                                    : "lbl_no"}
                                </label>
                              </div>
                            </div>
                            {error_agree && (
                              <span className="invalid_span">
                                {error_agree}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="button-center text-center pt-3">
                          <button type="submit" onClick={handleSubmitTwo}>
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_send")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_send"
                                  )[0]["value"] || "lbl_send"
                                : "lbl_send"
                              : "lbl_send"}
                          </button>
                        </div>
                      </form>
                    </ModalBody>
                  </Modal>
                  {/* <p className="pt-4 ag-p1">
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_agency_rent_info"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_agency_rent_info"
                          )[0]["value"] || "lbl_agency_rent_info"
                        : "lbl_agency_rent_info"
                      : "lbl_agency_rent_info"}
                  </p> */}
                   <p className="pt-4 ag-p1">
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_agency_rent_please-confirm"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_agency_rent_please-confirm"
                          )[0]["value"] || "lbl_agency_rent_please-confirm"
                        : "lbl_agency_rent_please-confirm"
                      : "lbl_agency_rent_please-confirm"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {loading && <Loading />}
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, { getContentDetails, postAgencyRent })(
  Dealership_lease
);
